/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

// Shared Firebase project with Valkyrie (see valkyrie/.env.* NEXT_PUBLIC_FIREBASE_*)
// Only for the Onboarding events tracking
const VALKYRIE_FIREBASE = {
  VALKYRIE_FIREBASE_API_KEY: 'AIzaSyDIKS-GTkTfQ7xySSuljM_DQ2jxBcv8SXo',
  VALKYRIE_FIREBASE_AUTH_DOMAIN: 'valkyrie-b494e.firebaseapp.com',
  VALKYRIE_FIREBASE_PROJECT_ID: 'valkyrie-b494e',
  VALKYRIE_FIREBASE_STORAGE_BUCKET: 'valkyrie-b494e.firebasestorage.app',
  VALKYRIE_FIREBASE_MESSAGING_SENDER_ID: '1005980904040',
  VALKYRIE_FIREBASE_APP_ID: '1:1005980904040:web:3f785ca9b3048d430e69dd',
  VALKYRIE_FIREBASE_MEASUREMENT_ID: 'G-L97PP0T0TW',
};

let env;

switch (process.env.REACT_APP_STAGE) {
  case 'development':
    env = {
      ...VALKYRIE_FIREBASE,
      REST_DOMAIN_URL: 'https://kycapi.wealthydev.in',
      GRAPH_URL: 'https://graph.buildwealthdev.in/graphql/',
      WEALTHY_WEBSITE_URL: 'https://www.wealthydev.in',
      VALKYRIE_URL: 'https://wealthydev.in/client/profile',
      WEALTHY_CDN_URL: 'https://i.wlycdn.com',
      WEALTHY_KYC_URL: 'http://kyc.wealthydev.in',
      RAZORPAY_URL: 'https://ifsc.razorpay.com/',
      RUDDERSTACK_WRITE_KEY: '2PvHllop7Dh74cNqOPzRjPF6tut',
      PARTNER_DASHBOARD_URL: 'https://app.buildwealthdev.in',
      APP_LINK_URL: 'https://applinks.buildwealth.in',
      MS_CLARITY_CODE: 'oyf6dzcp5l',
      ADD_FUNDS_URL: 'https://mylinks.wlthy.in/customers/add-funds/jSR9vMsm/',
    };
    break;

  case 'production':
    env = {
      ...VALKYRIE_FIREBASE,
      REST_DOMAIN_URL: 'https://kycapi.wealthy.in',
      GRAPH_URL: 'https://graph.buildwealth.in/graphql/',
      WEALTHY_WEBSITE_URL: 'https://www.wealthy.in',
      WEALTHY_CDN_URL: 'https://i.wlycdn.com',
      WEALTHY_KYC_URL: 'https://kyc.wealthy.in',
      RAZORPAY_URL: 'https://ifsc.razorpay.com/',
      IS_PRODUCTION: true,
      RUDDERSTACK_WRITE_KEY: '2PvGzH3SmS4AlTtOw8cTDqaISHX',
      PARTNER_DASHBOARD_URL: 'https://app.buildwealth.in',
      VALKYRIE_URL: 'https://wealthy.in/client/profile',
      APP_LINK_URL: 'https://applinks.buildwealth.in',
      MS_CLARITY_CODE: 'oyesczr1va',
      ADD_FUNDS_URL: 'https://mylinks.wlthy.in/customers/add-funds/jSR9vMsm/',
    };
    break;

  default:
    env = {
      ...VALKYRIE_FIREBASE,
      REST_DOMAIN_URL: 'https://kycapi.wealthydev.in',
      GRAPH_URL: 'https://graph.buildwealthdev.in/graphql/',
      WEALTHY_WEBSITE_URL: 'https://www.wealthydev.in',
      WEALTHY_CDN_URL: 'https://i.wlycdn.com',
      WEALTHY_KYC_URL: 'http://localhost:3000',
      RAZORPAY_URL: 'https://ifsc.razorpay.com/',
      IS_LOCAL: true,
      RUDDERSTACK_WRITE_KEY: '2PvHllop7Dh74cNqOPzRjPF6tut',
      PARTNER_DASHBOARD_URL: 'https://app.buildwealthdev.in',
      APP_LINK_URL: 'https://applinks.buildwealth.in',
      VALKYRIE_URL: 'https://wealthydev.in/client/profile',
      MS_CLARITY_CODE: 'oyf6dzcp5l',
      ADD_FUNDS_URL: 'https://mylinks.wlthy.in/customers/add-funds/jSR9vMsm/',
    };
}

export default env;
